export const TYPE_QUERY = 'type';
export const SESSION_KEY_DATA_QUERY = 'sessionKeyData';
export const GAME_QUERY = 'game';
export const PLATFORM_QUERY = 'platform';
export const ISSUE_TYPE_QUERY = 'issueType';
export const ISSUE_SUBTYPE_QUERY = 'issueSubType';
export const LOGIN_QUERY = 'login';
export const SOPORTO_KING_APP_ID = 90;

export const ENVIRONMENT = {
    DEV: 'dev',
    QA: 'qa',
    LIVE: 'live'
};

// Public Cloud reCAPTCHA site keys, shared with soporto-fe. Each key lives in that environment's GCP
// project (e.g. king-a-soporto-qa; LIVE uses king-a-soporto-prod) and is paired with that
// environment's soporto-recaptcha-secret.
export const RECAPTCHA_KEY = {
    [ENVIRONMENT.DEV]: '6LenhtAmAAAAAOtilQxdYcZPMdQWcqMV_j0Ef_L9',
    [ENVIRONMENT.QA]: '6Lc8brgmAAAAAC88suwbaPC-l1l0Xcd4ew4GUk_Z',
    [ENVIRONMENT.LIVE]: '6LezatUmAAAAAKLiT4mJKiMYi5roGpKOdvgM4GQY'
};

export const LOCAL_STORAGE_AUTH_KEY = 'auth-state';
export const AUTH_INITIAL_STATE = { isLoggedIn: false, cuid: null, sessionKey: null };
export const FORM_INITIAL_STATE = {
    email: {
        value: '',
        isValid: false
    },
    name: {
        value: '',
        isValid: false
    },
    game: {
        value: '',
        isValid: false
    },
    platform: {
        value: '',
        isValid: false
    },
    issueType: {
        value: '',
        isValid: false
    },
    issueSubType: {
        value: '',
        isValid: false
    },
    message: {
        value: '',
        isValid: false
    }
};



// WEBPACK FOOTER //
// ./src/constants.js